import React from 'react';
import { CatalogOrder } from '../clientContracts/productSeeding/catalogOrders/entities';

const CatalogOrderContext = React.createContext<CatalogOrder | null>(null);

export default CatalogOrderContext;
